// History dock (DRAW_PLAN §1 "History"): the undo list, newest last; click a step to go back to it.
import { useT, type MessageKey } from '../../../i18n';
import { useDesign } from '../../state';

export function HistoryDock() {
  const t = useT();
  const past = useDesign((st) => st.history.past);
  const future = useDesign((st) => st.history.future);
  const label = (l: string) => (l.startsWith('cmd') ? t(l as MessageKey) : l);
  return (
    <ol data-testid="design-history" style={{ margin: 0, paddingLeft: 18 }}>
      <li>
        <button onClick={() => stepTo(0)}>{t('historyOpen')}</button>
      </li>
      {past.map((e, i) => (
        <li key={`p${i}`}>
          <button onClick={() => stepTo(i + 1)}>{label(e.label)}</button>
        </li>
      ))}
      {future.map((e, i) => (
        <li key={`f${i}`} style={{ opacity: 0.45 }}>
          <button onClick={() => stepTo(past.length + i + 1)}>{label(e.label)}</button>
        </li>
      ))}
    </ol>
  );
}

/** Undo or redo until `n` steps are applied. */
function stepTo(n: number) {
  const st = useDesign.getState();
  for (let k = st.history.past.length; k > n; k--) useDesign.getState().undo();
  for (let k = useDesign.getState().history.past.length; k < n; k++) useDesign.getState().redo();
}
